import { render, staticRenderFns } from "./soldProductItem.vue?vue&type=template&id=4b8ef31e"
import script from "./soldProductItem.vue?vue&type=script&lang=js"
export * from "./soldProductItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports